"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.componentUnderTest = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ExperimentContext = require("../context/ExperimentContext");

var _TrackingContext = _interopRequireDefault(require("../context/TrackingContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Experiment = function Experiment(_ref) {
  var experimentName = _ref.experimentName,
      dimension = _ref.dimension,
      LoadingComponent = _ref.LoadingComponent,
      selectedVariant = _ref.selectedVariant,
      defaultVariant = _ref.defaultVariant,
      children = _ref.children;

  if (!experimentName) {
    throw new Error('An Experiment was rendered but was not given a name. Please ensure all Experiment components are given an experimentName prop.');
  }

  var _useExperimentContext = (0, _ExperimentContext.useExperimentContext)(),
      _useExperimentContext2 = _useExperimentContext.selectors,
      getExperiment = _useExperimentContext2.getExperiment,
      getExperimentVariant = _useExperimentContext2.getExperimentVariant,
      getState = _useExperimentContext2.getState;

  var _getState = getState(),
      isLoading = _getState.isLoading;

  var experiment = getExperiment(experimentName);

  var _getExperimentVariant = getExperimentVariant(experimentName, dimension),
      fetchedVariant = _getExperimentVariant.variant,
      fetchedDimension = _getExperimentVariant.dimension;

  var hasVariantValue = Boolean(selectedVariant || fetchedVariant);
  var variantToRender = selectedVariant || fetchedVariant || defaultVariant;

  var childToRender = _react.default.Children.toArray(children) // eslint-disable-next-line react/prop-types
  .find(function (_ref2) {
    var props = _ref2.props;
    return props.variant === variantToRender;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visitTracked = _useState2[0],
      setVisitTracked = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      impressionTracked = _useState4[0],
      setImpressionTracked = _useState4[1];

  var contextValue = (0, _react.useMemo)(function () {
    return hasVariantValue ? {
      experiment: experiment,
      experimentName: experimentName,
      dimensionName: fetchedDimension,
      variantName: variantToRender,
      shouldTrack: hasVariantValue,
      visitTracked: visitTracked,
      impressionTracked: impressionTracked,
      setVisitTracked: setVisitTracked,
      setImpressionTracked: setImpressionTracked
    } : {
      shouldTrack: false
    };
  }, [experiment, experimentName, fetchedDimension, variantToRender, hasVariantValue, visitTracked, impressionTracked, setVisitTracked, setImpressionTracked]);

  if (isLoading && !hasVariantValue) {
    return LoadingComponent && _react.default.createElement(LoadingComponent, null) || childToRender || null;
  }

  return childToRender ? _react.default.createElement(_TrackingContext.default.Provider, {
    value: contextValue
  }, childToRender) : null;
};

Experiment.propTypes = {
  experimentName: _propTypes.string.isRequired,
  defaultVariant: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  selectedVariant: _propTypes.string,
  dimension: _propTypes.string,
  LoadingComponent: _propTypes.func
};
Experiment.defaultProps = {
  dimension: null,
  LoadingComponent: null,
  selectedVariant: null
};
var componentUnderTest = Experiment;
exports.componentUnderTest = componentUnderTest;

var _default = (0, _react.memo)(Experiment);

exports.default = _default;